import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import LessonDetailPanel from "./LessonDetailPanel";

// Lesson List Component
const LessonList = ({
  lessons,
  selectedLesson,
  onLessonClick,
  onClosePanel,
  onSave,
  onDelete,
  onEdit,
}) => {
  if (lessons.length === 0) {
    return (
      <div className="text-center" style={{ padding: "80px 20px" }}>
        <div
          style={{
            backgroundColor: "#fafafa",
            borderRadius: "16px",
            padding: "48px 32px",
            border: "1px solid #f0f0f0",
          }}
        >
          <FontAwesomeIcon
            icon={faMoon}
            size="3x"
            style={{ color: "#F0D6B5", opacity: 0.4, marginBottom: "24px" }}
          />
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "12px",
              fontWeight: "600",
            }}
          >
            No lessons yet
          </h4>
          <p style={{ color: "#6c757d", marginBottom: "0", fontSize: "16px" }}>
            Create your first Night School lesson to get started
          </p>
        </div>
      </div>
    );
  }

  // Group lessons by chapter/subject
  const lessonsByChapter = {};
  lessons.forEach((doc) => {
    const lesson = { id: doc.id, ...doc.data() };
    // Normalize chapter name by trimming whitespace and consistent casing
    const rawSubject = lesson.subject || "Uncategorized";
    const chapter = rawSubject.trim().replace(/\s+/g, " "); // Normalize multiple spaces to single space

    if (!lessonsByChapter[chapter]) {
      lessonsByChapter[chapter] = [];
    }
    lessonsByChapter[chapter].push(lesson);
  });

  // Sort lessons within each chapter by lesson_number
  Object.keys(lessonsByChapter).forEach((chapter) => {
    lessonsByChapter[chapter].sort(
      (a, b) => (a.lesson_number || 0) - (b.lesson_number || 0)
    );
  });

  return (
    <div style={{ display: "flex", gap: "24px", minHeight: "70vh" }}>
      {/* Main Content */}
      <div style={{ flex: selectedLesson ? "0 0 50%" : "1" }}>
        <Row>
          {Object.entries(lessonsByChapter).map(([chapter, chapterLessons]) => (
            <Col lg={4} md={6} sm={12} key={chapter} className="mb-4">
              {/* Chapter Card */}
              <Card
                style={{
                  border: "none",
                  borderRadius: "16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  backgroundColor: "#fefefe",
                  height: "100%",
                }}
              >
                <Card.Body
                  style={{
                    padding: "24px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div style={{ flex: 1 }}>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontWeight: "700",
                          marginBottom: "6px",
                          fontSize: "18px",
                          lineHeight: "1.3",
                        }}
                      >
                        {chapter}
                      </h4>
                      <p
                        style={{
                          color: "#6c757d",
                          marginBottom: "0",
                          fontSize: "14px",
                        }}
                      >
                        {chapterLessons.length} lesson
                        {chapterLessons.length !== 1 ? "s" : ""}
                      </p>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#F0D6B5",
                        color: "#635956",
                        padding: "6px 12px",
                        borderRadius: "16px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Chapter
                    </div>
                  </div>

                  {/* Lessons List */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                      flex: 1,
                    }}
                  >
                    {chapterLessons.map((lesson) => (
                      <div
                        key={lesson.id}
                        onClick={() => onLessonClick(lesson)}
                        style={{
                          padding: "12px 16px",
                          borderRadius: "10px",
                          backgroundColor:
                            selectedLesson?.id === lesson.id
                              ? "#f8f9fa"
                              : "transparent",
                          border:
                            selectedLesson?.id === lesson.id
                              ? "2px solid #F0D6B5"
                              : "1px solid #f0f0f0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedLesson?.id !== lesson.id) {
                            e.target.style.backgroundColor = "#f8f9fa";
                            e.target.style.borderColor = "#e9ecef";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedLesson?.id !== lesson.id) {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderColor = "#f0f0f0";
                          }
                        }}
                      >
                        <div
                          className="d-flex align-items-flex-start"
                          style={{ flex: 1 }}
                        >
                          <span
                            style={{
                              backgroundColor: "#e9ecef",
                              color: "#495057",
                              padding: "3px 6px",
                              borderRadius: "4px",
                              fontSize: "11px",
                              fontWeight: "600",
                              marginRight: "10px",
                              minWidth: "40px",
                              textAlign: "center",
                              marginTop: "2px",
                            }}
                          >
                            #{lesson.lesson_number}
                          </span>
                          <div style={{ flex: 1 }}>
                            <h6
                              style={{
                                color: "#2c3e50",
                                marginBottom: "2px",
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "1.3",
                              }}
                            >
                              {lesson.name}
                            </h6>
                            {lesson.lesson_maxim && (
                              <p
                                style={{
                                  color: "#6c757d",
                                  marginBottom: "0",
                                  fontSize: "12px",
                                  lineHeight: "1.3",
                                }}
                              >
                                {lesson.lesson_maxim.length > 50
                                  ? lesson.lesson_maxim.substring(0, 50) + "..."
                                  : lesson.lesson_maxim}
                              </p>
                            )}
                          </div>
                        </div>

                        <div
                          className="d-flex align-items-center"
                          style={{ marginLeft: "8px" }}
                        >
                          {lesson.suggested_questions &&
                            lesson.suggested_questions.length > 0 && (
                              <span
                                style={{
                                  color: "#6c757d",
                                  fontSize: "10px",
                                  marginRight: "8px",
                                  backgroundColor: "#f8f9fa",
                                  padding: "2px 6px",
                                  borderRadius: "8px",
                                }}
                              >
                                {lesson.suggested_questions.length}
                              </span>
                            )}
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            style={{
                              color: "#adb5bd",
                              transform:
                                selectedLesson?.id === lesson.id
                                  ? "rotate(180deg)"
                                  : "none",
                              transition: "transform 0.2s ease",
                            }}
                            size="xs"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Side Panel */}
      {selectedLesson && (
        <div
          style={{
            flex: "0 0 50%",
            backgroundColor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            border: "1px solid #f0f0f0",
            maxHeight: "80vh",
            overflowY: "auto",
            position: "sticky",
            top: "20px",
          }}
        >
          <LessonDetailPanel
            lesson={selectedLesson}
            onClose={onClosePanel}
            onSave={onSave}
            onDelete={onDelete}
            onEdit={onEdit}
          />
        </div>
      )}
    </div>
  );
};

export default LessonList;
